export default function () {
  return {
    activity: {
      activites: [],
      daily_activites: [],
      daily_types: [],
      customers: []
    },
    advance: [],
    sales: [],
    advBarOption: {
      show: true,
      position: 'insideBottom',
      distance: '10',
      align: 'left',
      verticalAlign: 'middle',
      rotate: '90',
      formatter: '{c}  {a}',
      fontSize: 14
    },
    //
    geoCS: [],
    geoCustomer: [],
    geoCustomerSelected: [],
    geoCustomerPercentage: [],
    totalCustomer: 0,

    regions: [],
    geoPB: [],
    geoPBSelected: [],
    totalPB: 0,

    geoInstrument: [],
    geoInstrumentSelected: [],
    totalInstrument: 0,

    months: [
      'SM',
      'January',
      'February',
      'March',
      'April',
      'May',
      'June',
      'July',
      'August',
      'September',
      'October',
      'November',
      'December'
    ]
  }
}
